export function discoveredRefreshSuccessMessage(meta) {
  if (!meta || typeof meta !== 'object') {
    return 'Discovered repositories refreshed from GitHub.';
  }
  const gh = meta.githubRepoCount;
  const added = meta.unassignedImportedAdded;
  const updated = meta.unassignedImportedUpdated;
  const listed = meta.unassignedListedCount;
  if (typeof gh === 'number' && typeof listed === 'number' && listed === 0 && gh > 0) {
    return 'Refresh completed. No unassigned repos to show—all organisation repos may already be connected to a project.';
  }
  if (
    typeof gh === 'number' &&
    typeof added === 'number' &&
    typeof updated === 'number' &&
    typeof listed === 'number'
  ) {
    return `Discovered repos refreshed from GitHub (${gh} org repos seen; ${added} new unassigned records; ${updated} updated; ${listed} unassigned listed).`;
  }
  return 'Discovered repositories refreshed from GitHub.';
}

/** Resolve short repo name + owner for display (falls back to parsing `fullName`). */
export function repositoryNameAndOwner(repo) {
  const full = (repo.fullName || '').trim();
  let name = (repo.name || '').trim();
  let owner = (repo.owner || '').trim();
  if (full.includes('/')) {
    const idx = full.lastIndexOf('/');
    const fullOwner = full.slice(0, idx).trim();
    const fullRepo = full.slice(idx + 1).trim();
    if (!owner) owner = fullOwner;
    if (!name) name = fullRepo;
  }
  if (!name) name = full || '—';
  const fullDisplay = full || (owner ? `${owner}/${name}` : name);
  return { name, owner, fullDisplay };
}
